/*global chrome*/

import React from 'react';
import { observer } from 'mobx-react';

import ProgressBar from './ProgressBar';

// Translations
import translate from '../Translate.js';

const SessionEndAutomated = observer(
  class SessionEndAutomated extends React.Component {
    constructor() {
      super();

      this.state = {
        extensionId: null,
        sessionData: null,
        currentUploadCount: null,
        totalUploadCount: null
      };

      const receiveMessage = event => {
        if (!event.data.message) return;

        switch (event.data.message) {
          case 'eventsStillUploading':
            this.setState({
              totalUploadCount: event.data.totalCount,
              currentUploadCount: event.data.totalCount,
              extensionId: event.data.extensionId
            });
            break;

          case 'sendQueueCount':
            this.setState({
              currentUploadCount: event.data.queueCount,
              extensionId: event.data.extensionId,
              totalUploadCount: this.state.totalUploadCount
                ? this.state.totalUploadCount
                : event.data.queueCount * 2
            });
            if (event.data.queueCount === 0) clearInterval(this.checkUploadsInterval);
            break;

          default:
            break;
        }
      };

      window.addEventListener('message', receiveMessage, false);

      this.checkUploadsInterval = setInterval(() => {
        if (this.state.extensionId && this.state.totalUploadCount)
          chrome.runtime.sendMessage(this.state.extensionId, {
            message: 'getEventsToUploadCount'
          });
      }, 250);
    }

    componentDidMount() {
      const { SessionStore } = this.props.store;

      SessionStore.hideHeader = true;
      SessionStore.hideFooter = true;

      // Wait for extension info to be retrieved
      const extensionDelay = setInterval(() => {
        if (SessionStore.extensionInfo) {
          clearInterval(extensionDelay);
          this.getSessionData(SessionStore.extensionInfo.extensionId);
        }
      }, 100);
    }

    getSessionData(extensionId) {
      chrome.runtime.sendMessage(
        extensionId,
        { message: 'getSessionStart' },
        response => {
          if (response) {
            this.setState({
              session: response
            });

            this.stopSession(extensionId);
          }
        }
      );
    }

    stopSession(extensionId) {
      chrome.runtime.sendMessage(extensionId, { message: 'stopSession' }, response => {
        if (response.status === 'ERROR' || response.errorMessage) {
          alert(response.errorMessage);
          return;
        }
      });
    }

    uninstall = () => {
      const { translation } = this.props;
      const { SessionStore } = this.props.store;
      const { extensionInfo } = this.props.store.SessionStore;

      chrome.runtime.sendMessage(
        extensionInfo.extensionId,
        { message: 'uninstall' },
        response => {
          if (response && response.status) {
            console.log('Did not uninstall');
          } else {
            SessionStore.showDialog(translation.uninstalled);
          }
        }
      );
    };

    renderActions = () => {
      const { translation } = this.props;
      const { session } = this.state;

      if (!session) return <div />;

      const { email, firstName, lastName } = session.user;
      const sessionSid = session.session.sid;
      const { extVersion } = session;
      const { installSid } = session.session;

      return (
        <div className="actions">
          <a
            className="btn btn--inline"
            href={`https://smarterservices.typeform.com/to/uNlipH?email=${email}&sessionsid=${sessionSid}&firstname=${firstName}&lastname=${lastName}&extensionversion=${extVersion}&installsid=${installSid}`}
          >
            {translation.survey}
          </a>
        </div>
      );
    };

    getUploadPercentage = () =>
      (this.state.totalUploadCount - this.state.currentUploadCount > 0
        ? ((this.state.totalUploadCount - this.state.currentUploadCount) /
            this.state.totalUploadCount) *
          100
        : 0
      ).toFixed(0);

    isUploading = () => {
      if (!this.state.totalUploadCount) return false;
      return this.getUploadPercentage() > -1 && this.getUploadPercentage() < 100;
    };

    isUploadingFinished = () => this.getUploadPercentage() >= 100;

    renderEndContent = () =>
      this.state.session ? (
        <div>
          <p>{this.props.translation.body}</p>
          {this.renderActions()}
        </div>
      ) : (
        <p>{this.props.translation.body_alt} </p>
      );

    render() {
      const { translation } = this.props;

      return (
        <main tabIndex="0" id="main-content" className="page page--error wrap">
          {this.isUploading() 
            ? <div className="panel--medium">
                <h1 className="panel__title panel__title--alt">{translation.uploading_heading}</h1>
                <ProgressBar value={this.getUploadPercentage()} />
                <p>{translation.uploading}</p>
              </div>
            : <div className="panel--medium">
                <h1 className="panel__title panel__title--alt">{translation.heading}</h1>
                {this.renderEndContent()}
              </div>
          }
        </main>
      );
    }
  }
);

export default translate('SessionEndAutomated')(SessionEndAutomated);



// WEBPACK FOOTER //
// ./src/app/components/SessionEnd/SessionEndAutomated.js